export function getBeaconId(): string {
  return getFromServerTiming("beacon") ?? generateBeaconId();
}

export function generateBeaconId(): string {
  // for users from GDPR countries if they did not give consent for tracking
  // we assign random values to session cookies; should match results of:
  // https://developer.fastly.com/reference/vcl/functions/randomness/randomstr/
  const validCharacters =
    "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz_-";

  return Array.from(
    { length: 10 },
    () => validCharacters[Math.floor(Math.random() * validCharacters.length)],
  ).join("");
}

export function getBeaconV2(): string {
  return getFromServerTiming("b2") ?? generateBeaconV2();
}

export function generateBeaconV2(): string {
  return `${generateBeaconId()}.${Date.now()}`;
}

type BeaconType = "beacon" | "b2";
function getFromServerTiming(beaconType: BeaconType): string | null {
  try {
    const performanceEntry = performance.getEntriesByType(
      "navigation",
    )[0] as PerformanceResourceTiming;
    if (!performanceEntry.serverTiming) {
      return null;
    }
    const beaconEntry = performanceEntry.serverTiming.find(
      (entry) => entry.name === beaconType,
    );

    // debug code to be removed in the future
    if (
      !beaconEntry &&
      document
        .querySelector("html")
        ?.classList.contains("sse-dtnr-179-variant1")
    ) {
      window["dtnrObservability"] = window["dtnrObservability"] || [];
      window["dtnrObservability"].push(
        "getFromServerTiming failed for(" + beaconType + ")",
      );
    }

    return beaconEntry?.description ?? null;
  } catch {
    return null;
  }
}
